module.exports = __webpack_public_path__ + "img/escuelas2019.5a3bddab.jpg";